<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:34:28
 * @Description: 审核信息
 -->

<template>
  <div class="check-info-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'check-info',
  computed: {
    showRouterView() {
      return window.location.href.findIndex('check-info');
    }
  }
};
</script>
<style lang="less" scope>
.check-info-wrapper {
  padding: 40px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  .link-item {
    display: flex;
    border-bottom: 1px dashed #ddd;
    justify-content: space-between;
    align-items: center;
    height: 50px;
  }
  img {
    width: 100%;
  }
}
</style>
